import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import type { AppDispatch } from '../../../redux/store';
import { logout as reduxLogout } from '../../../redux/auth';
import { useTabAuth } from '../../../hooks/useTabAuth';

export const Logout: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const { logout: tabAuthLogout } = useTabAuth();

  useEffect(() => {
    dispatch(reduxLogout());
    tabAuthLogout();
    navigate('/login', { replace: true });
  }, [dispatch, tabAuthLogout, navigate]);

  return null;
};
